import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Pause = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <g>
      <title>Pause</title>
      <g fill="currentColor" fillRule="evenodd">
        <path d="M5 9.5h1v-5H5zM8 9.5h1v-5H8z" />
        <path d="M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 1c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Pause;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Pause.js